import { ExtendedListing } from '../models/Listing';
import { ListingQuery } from '../types/api.graphql';

export const setSVGChildColors = (color: string, useFill?: boolean) => {
  return `svg {
      path {
        ${useFill ? `fill: ${color};` : `stroke: ${color};`}
      }
      rect {
        ${useFill ? `fill: ${color};` : `stroke: ${color};`}
      }
      line {
        ${useFill ? `fill: ${color};` : `stroke: ${color};`}
      }
      circle {
        ${useFill ? `fill: ${color};` : `stroke: ${color};`}
      }
    }`;
};

export const createExtendedListingFromListing = (node: ListingQuery['listing']): ExtendedListing => {
  return {
    ...node.vehicle,
    activity: node.activity,
    sharingOrganization: node.sharingOrganization,
    receivingOrganization: node.receivingOrganization,
    receivingUser: node.receivingUser,
    listingId: node.id,
    listingValuations: node.valuations,
    sharingUser: node.sharingUser,
    parentListing: node.parentListing,
    listingCurrentStatus: node.currentStatus,
    listingStatuses: node.statuses,
    shared: node.shared,
    vehicleId: node.vehicle.id,
    tags: node.tags,
    appraisals: node.appraisals,
    currentOffer: node.currentOffer,
    previousOffer: node.offerHistory?.find((offer) => offer?.id !== node.currentOffer?.id),
    currentInternalValuation: node.currentInternalValuation,
    previousInternalValuation: node.internalValuationHistory?.find(
      (val) => val?.id !== node.currentInternalValuation?.id,
    ),
    isShared: !!node.parentListing,
    isSaved: node.saved,
    isConsumer: !!node.lead?.leadConsumer,
    leadData: {
      user: {
        firstName: node.lead?.leadConsumer?.firstName,
        lastName: node.lead?.leadConsumer?.lastName,
        email: node.lead?.leadConsumer?.email,
        phoneNumber: node.lead?.leadConsumer?.phone,
      },
      valuationRange: node.lead?.range,
      zipCode: node.lead?.valuationZip,
    },
  };
};
